<script>
export default {
  props: ['item'],
  data() {
    return {


      temp_assign_to: null,

      users_loading: true,
      users_filters: {
        total: 0,
        selects: ['id', 'name', 'email', 'phone', 'avatar'],
        orderbys: {
          last_active: 'desc',
        }
      },
      users: [],
    }
  },
  created() {
    this.fetch_users();
    if(!this.item.assigned_to) {
      this.item.assigned_to = [];
      this.$forceUpdate();
    }
    if(!this.item.content) {
      this.item.content = "";
      this.$forceUpdate();
    }
  },
  methods: {
    fetch_users() {
      this.users_loading = true;
      this.$http.get('/api/users/fetch', {params: this.users_filters}).then(res => {
        // console.log(res);
        this.users = res.data.data;
        this.users.unshift({id:'', email: 'None', name: 'None'});
        this.users_loading = false;
      }).catch(res => { this.users_loading = false; this.popupErrors(res); });
    },
    assign_user() {
      if(this.temp_assign_to.id) {
        var already = false;
        for(var i in this.item.assigned_to) {
          if(this.temp_assign_to.id == this.item.assigned_to[i].id) { already = true; }
        }
        if(!already) {
          this.item.assigned_to.push(this.temp_assign_to);
          this.$forceUpdate();
        }
      }
    },
    un_assign_user(index) {
      var n = this.$noty.error('Are you sure you would like to remove this user?', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light', res => {
            this.item.assigned_to.splice(index, 1);
            this.$forceUpdate();
            n.close();
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { });
    },
    changeEditor(type) {
      var n = this.$noty.error('<div class="p-3"><h3 class="text-white">Are you sure you would like to change editors?</h3><div>Changing the content type can cause data to be lost, specifically when changing to the Document editor as all data will be parsed.</div></div>', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light', res => {
            this.item.content_type = type;
            this.$forceUpdate();
            n.close();
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { });
    },
  }
}
</script>

<template>
  <div>
    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Task details :</h5>
    <div class="row mb-4">
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="Title :" v-model="item.title" Required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="Textarea" Title="Summary :" v-model="item.summary"></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Status :" v-model="item.status" :Options="[{name: 'Trash', value: '0'},{name: 'Draft', value: '1'},{name: 'Active', value: '2'},{name: 'Hold', value: '3'},{name: 'Complete', value: '4'}]" required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Priority :" v-model="item.priority" :Options="[{name: 'Low', value: '1'},{name: 'Normal', value: '2'},{name: 'High', value: '3'}]" required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="Date" Title="Start date :" v-model="item.start_date" placeholder="Select..."></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="Date" Title="Due date :" v-model="item.due_date" placeholder="Select..."></w-field>
      </div>
    </div>

    <div class="form-group mb-4">
      <label>Assigned to :</label>
      <div class="row m-0 mb-3">
        <div class="col-10 p-0">
          <multiselect id="input-lead_recipients" v-model="temp_assign_to" :options="users" :preserve-search="true" placeholder="Select..." label="name" track-by="id" required>
            <template slot="singleLabel" slot-scope="props">{{props.option.email}} <span class="text-muted">({{props.option.name}})</span></template>
            <template slot="option" slot-scope="props">{{props.option.email}} <span class="text-muted">({{props.option.name}})</span></template>
          </multiselect>
        </div>
        <div class="col-2 p-0">
          <button class="btn btn-block btn-success" type="button" v-tippy content="Assign a user" @click="assign_user"><Icon icon="ri:add-line" height="18"></Icon> Add</button>
        </div>
      </div>

      <div v-for="(assign, assign_i) in item.assigned_to" :key="assign_i" class="d-inline-block mr-2 mb-2 align-top _c-pointer" v-tippy :content="`<div class='col p-0 small'><h6 class='mb-0'>`+assign.name+`</h6><div class='text-muted small _lh-16'>`+assign.email+`</div><div class='text-muted small _lh-16'>`+formatPhone(assign.phone)+`</div></div><div class='text-danger small'>Click to remove</div>`" @click="un_assign_user(assign_i)">
        <img v-if="assign.avatar" :src="formatImage(assign.avatar)" class="_w-50 rounded">
        <avatar v-else :username="assign.name" :size="50" :rounded="false" class="rounded"></avatar>
      </div>

    </div>


    <!-- <div class="my-5">

      <div class="border mb-1">
        <label>users :</label>
        <div v-for="(assign, assign_i) in item.users" :key="assign_i">{{assign.name}}</div>
      </div>

    </div> -->


    <div class="form-group mb-4">
      <label>Project folders :</label>
      <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.project_folders">
        <transition-group tag="div">
          <div v-for="(menu, menu_i) in item.project_folders" :key="'a'+menu_i">
            <div class="input-group ">
              <input type="text" class="form-control" placeholder="Folder path..." v-model="menu.title">
              <div class="input-group-append">
                <w-field SimpleDataType="String List, Single" v-model="menu.status" :Options="[{name: 'No', value: '0'},{name: 'Yes', value: '1'}]" v-tippy content="Has this task been implemented into this project?" required></w-field>
                <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.project_folders.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
              </div>
            </div>
          </div>
        </transition-group>
      </draggable>
      <div class="">
        <button class="btn btn-success mr-2" type="button" @click="item.project_folders.push({title: '', status: 0})"><Icon icon="ri:add-line" height="18"></Icon> Add</button>
      </div>
    </div>

    <div class="form-group">
      <label>Content :</label>
      <!-- <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Content :</h5> -->
      <div class="">
        <div class="row m-0 mb-0">
          <div class="col-12 col-sm-6 p-0">
            <button type="button" class="btn btn-block" :class="item.content_type == 'doc' ? 'btn-primary' : 'btn-white'" @click="changeEditor('doc')">Document editor</button>
          </div>
          <div class="col-12 col-sm-6 p-0">
            <button type="button" class="btn btn-block" :class="item.content_type == 'html' ? 'btn-primary' : 'btn-white'" @click="changeEditor('html')">HTML Editor</button>
          </div>
        </div>
        <component v-if="item.content_type == 'html'" is="PrismEditorMain" v-model="item.content"></component>
        <component v-else is="CkRichEditor" v-model="item.content"></component>
      </div>
    </div>

    <div class="clearfix mt-3"></div>

  </div>
</template>
